import app from '@/app';
import templateUrl from './unit-price-tables-search.html';

/* @ngInject */
function Controller($controller, $state, UnitPriceTable, Principal) {
  var $ctrl = this;
  $ctrl.currentAccount = null;

  Principal.identity().then(account => {
    $ctrl.currentAccount = account;
  });

  $controller('AbstractPageSortController', { $ctrl: $ctrl });

  var resource = UnitPriceTable;

  var transition = $ctrl.transition;
  $ctrl.transition = function(params) {
    transition(params);
    $ctrl.name = params.name;
    resource.query({ query: $ctrl.name, page: $ctrl.page, size: $ctrl.size, sort: $ctrl.sort }, function(data) {
      $ctrl.entities = data.content;
      $ctrl.count = data.totalElements;
    });
  };

  $ctrl.remove = id => resource.remove({ id: id }, () => $state.reload()).$promise;

  $ctrl.onQueryChange = function() {
    $ctrl.isSearching = true;
    var params = {
      query: $ctrl.name,
      page: 0,
      size: $ctrl.size,
      sort: $ctrl.sort
    };
    resource.query(params, function(data) {
      $ctrl.entities = data.content;
      $ctrl.count = data.totalElements;
    }).$promise.finally(function() {
      $ctrl.isSearching = false;
    });
  };
}



const component = {
  templateUrl,
  controller: Controller,
  bindings: {
    $transition$: '<'
  }
};

app.component('unitPriceTablesSearch', component);
